import InnerFormSection from 'components/ui-components/forms/InnerFormSection';

const CompanyTypeSelector = ({
  selectedCompanyType,
  handlePrevStep,
  className,
}) => (
  <InnerFormSection title="Company Type" className={className}>
    <div className="fl">
      <div className="ff-body fs-16 fw-400 tc-secondary">
        {selectedCompanyType}
      </div>
      <button
        className="cef-btn--as-ul-link ml-12 fw-400"
        type="button"
        onClick={() => handlePrevStep()}>
        Change
      </button>
    </div>
  </InnerFormSection>
);

export default CompanyTypeSelector;
